import React, { useEffect, useState } from 'react'
import { ContractsModel, OnlinePaymentModal } from '../../../../types/contracts/contractsModel'
import AccountHeader from './account_header/AccountHeader'
import AccountBody from './account_body/AccountBody'
import fetchFactory from '../../../../utils/fetchFactory'
import { configEnum } from '../../../../enums/fetchFactoryEnum'
import { PostAccountStatementModel, Releve } from './account_model'
import { convertAccountStatementReleve } from './accountMapper'
import Loader from '../../../../components/loader/Loader'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../styles'
import { onlinePaymentMode, PRL_AUTO } from '../../../../enums/contractsEnum'
import PaymentDialog from './payment/PaymentDialog'

const initPaymentModal: OnlinePaymentModal = {
    open: false,
    type: onlinePaymentMode.all,
    amount: 0,
    lease: '',
    facture: undefined
}

const useStyle = makeStyles((theme) => ({
    ...styles(theme),
    loaderContainer: {
        paddingTop: 20,
        backgroundColor: theme.palette.blue['5']
    }
}))

interface AcceptingProps {
    contract: ContractsModel,
    isLargeScreen: boolean,
}

type AccountProps = AcceptingProps

const Account: React.FC<AccountProps> = (
    {
        contract,
        isLargeScreen
    }
) => {
    const classes = useStyle()
    const currentYear = new Date().getFullYear()
    const listYear = [currentYear, currentYear - 1, currentYear - 2]
    const [selectedYear, setSelectedYear] = React.useState<number>(listYear[0])
    const [releves, setReleves] = React.useState<Releve[]>([])
    const [loadingAccount, setLoadingAccount] = useState<boolean>(false)
    const [paymentModal, setPaymentModal] = useState<OnlinePaymentModal>(initPaymentModal)
    const [pastPayment, setPastPayment] = useState<boolean>(true)

    //Fetch account statement for selected contract
    useEffect(() => {
        setLoadingAccount(true)
        const dataReleves: PostAccountStatementModel = {
            numero_bail: contract.lease
        }
        fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/compte/getReleves`,
            {
                body: JSON.stringify(dataReleves),
                method: configEnum.post
            })
            .then(
                (data: any) => {
                    if (!Array.isArray(data)) {
                        setReleves([])
                    } else {
                        setReleves(convertAccountStatementReleve(data))
                    }
                }
            )
        fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/payment/paymentLocked`,
            {
                body: JSON.stringify(
                    {
                        contractId: contract.lease
                    }
                ),
                method: configEnum.post
            })
            .then(
                (response: any) => setPastPayment(response)
            )
            .catch(
                () => setPastPayment(false)
            )
            .finally(
                () => setLoadingAccount(false)

            )
    }, [contract, setLoadingAccount])

    //Filter releves when year is changed
    const filterReleves = () => releves.filter(doc => doc.operation_date.getFullYear() === selectedYear)

    return (
        <>
            {
                loadingAccount ?
                    <div className={classes.loaderContainer}>
                        <Loader />
                    </div>
                    :
                    <>
                        {
                            contract.typeDePaiement !== PRL_AUTO && (
                                <AccountHeader
                                    solde={contract.balance === 0 ? contract.balance : -(contract.balance)}
                                    isLargeScreen={isLargeScreen}
                                    setOpenPayment={() => setPaymentModal({ open: true, type: onlinePaymentMode.all, amount: contract.balance, lease: contract.lease })}
                                    paymentDisabled={!pastPayment}
                                />
                            )
                        }

                        <AccountBody
                            paymentDisabled={!pastPayment}
                            contract={contract}
                            releves={filterReleves()}
                            listYear={listYear}
                            selectedYear={selectedYear}
                            setSelectedYear={setSelectedYear}
                            isLargeScreen={isLargeScreen}
                            setOpenPayment={(amount, facture, piece_numero) => setPaymentModal({ open: true, type: onlinePaymentMode.partial, facture, amount, lease: contract.lease, piece_numero})}
                        />
                        <PaymentDialog
                            closeDialog={() => setPaymentModal(initPaymentModal)}
                            paymentModal={paymentModal}
                        />
                    </>
            }

        </>
    )
}
export default Account
